



























































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { warning } from "@/utils/find";

@Component
export default class freightPopup extends Vue {
  loading: boolean=false;//加载遮罩
  loadingBtn: boolean=false;
  allAddress: Array<object>=[];//地址接口
  money: object={initData:0,initFreight:0,continueData:0,continueFreight:0,topData:0}

  @Prop(Object) freightPopupData!:object;
  @Watch('freightPopupData', { immediate: true, deep: true })
  onPersonChanged1(val, oldVal) {
    this.allAddress=val['addressList'];
    this.money=val['money']
  }
  // 多选地址
  handleCheckAllChange(val,index) {
    let list=[];
    (this.allAddress[index]['childList'] as any).forEach(item=>{
      if(!item.disable){
        list.push(item.addressId as never)
      }
    });
    (this.allAddress[index]['checkedCities'] as any)=val ? list : [];
    (this.allAddress[index]['isIndeterminate'] as Boolean) = false;
    let array=[];
    (this.allAddress[index]['childList'] as any).forEach(item=>{
      if(!item.disable){
        let obj={
          provinceName:this.allAddress[index]['addressName'] as String,
          provinceId:this.allAddress[index]['addressId'] as Number,
          cityName:item.addressName as String,
          cityId:item.addressId as Number
        }
        array.push(obj as never)
      }
    });
    (this.allAddress[index]['addressInfos'] as any)=val ? array : [];
    if(val){
      (this.allAddress[index]['checkedCountLength'] as Number)=list.length;
      if(list.length==(this.allAddress[index]['childList'] as any).length){
        (this.allAddress[index]['checkAll'] as Boolean) = true;
        (this.allAddress[index]['isIndeterminate'] as Boolean) = false;
      }else{
        (this.allAddress[index]['checkAll'] as Boolean) = false;
        (this.allAddress[index]['isIndeterminate'] as Boolean) = true;
      }
    }else{
      (this.allAddress[index]['checkedCountLength'] as Number)=0;
    }
  }
  // 多选地址
  handleCheckedCitiesChange(value,index) {
    if(value.length>0){
      (this.allAddress[index]['checkedCountLength'] as Number)=value.length;
      let checkedCount=value.length;
      (this.allAddress[index]['checkAll'] as Boolean) = checkedCount === (this.allAddress[index]['childList'] as any).length;
      (this.allAddress[index]['isIndeterminate'] as Boolean) = checkedCount > 0 && checkedCount < (this.allAddress[index]['childList'] as any).length;
      let ary=[];
      value.forEach(element => {
        let inds=(this.allAddress[index]['childList'] as any).findIndex(item=>{
          return element==item.addressId
        })
        let objs={
          provinceName:this.allAddress[index]['addressName'] as String,
          provinceId:this.allAddress[index]['addressId'] as Number,
          cityName:this.allAddress[index]['childList'][inds]['addressName'],
          cityId:this.allAddress[index]['childList'][inds]['addressId']
        }
        ary.push(objs as never)
      });
      (this.allAddress[index]['addressInfos'] as any)=ary;
    }else{
      (this.allAddress[index]['addressInfos'] as any)=[];
      (this.allAddress[index]['checkAll'] as Boolean) = false;
      (this.allAddress[index]['isIndeterminate'] as Boolean) = false;
      (this.allAddress[index]['checkedCountLength'] as Number)=0;
    }
  }
  // 取消
  cancel(){
    this.$emit('cancel');
  }
  // 确定
  determine(){
    let data=this.allAddress;
    let addressInfos=[];
    let money=this.money;
    data.forEach(item=>{
      if((item['addressInfos'] as any).length>0){
        addressInfos=addressInfos.concat(item['addressInfos'])
      }
    });
    if(addressInfos.length<=0){
      warning('请选择配送区域',1000);
    }else if(money['initData']<=0){
      warning('首件(件)不能为0',1000);
    }else if(money['initFreight']<=0){
      warning('首件(元)不能为0',1000);
    }else if(money['continueData']<=0){
      warning('续件(件)不能为0',1000);
    }else if(money['continueFreight']<=0){
      warning('续件(元)不能为0',1000);
    }else if(money['topData']<=0){
      warning('满件包邮不能为0',1000);
    }else{
      let data={
        ids:this.freightPopupData['ids'],
        addressInfos,
        initData:money['initData'],
        initFreight:money['initFreight'],
        continueData:money['continueData'],
        continueFreight:money['continueFreight'],
        topData:money['topData']
      }
      this.$emit('preserve',data);
    }
  }
}
